var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports", "./renderCustomValance", "./canvas", "./design", "./designbook.models", "./util", "./dialogs/share", "./url"], function (require, exports, renderCustomValance_1, canvas_1, design_1, designbook_models_1, util_1, share_1, url_1) {
    "use strict";
    exports.__esModule = true;
    var cdnHost = 'www.elegantcurtain.com';
    var productKindFrom = function (t) {
        switch (t) {
            case renderCustomValance_1.ProductType.FullSet:
                return 'Full set';
            case renderCustomValance_1.ProductType.DrapeOnly:
                return 'Panel only';
            case renderCustomValance_1.ProductType.ValanceOnly:
                return 'Valance only';
        }
        throw new Error("unknown product type " + t);
    };
    function getFabricFromAsset($fabric) {
        var fabricId = $fabric.data('asset_id');
        var fabric = fabricMap_7[fabricId];
        return {
            name: fabric.name,
            material: $($(fabric.description).last()).text(),
            photo: {
                thumbnail: fabric.pictures[0].details,
                full: fabric.pictures[0].full
            }
        };
    }
    function getFabricFrom(spec) {
        var fabricCode = spec.fabricMain;
        var $fabric = $("img.asset[codeName$=\"" + fabricCode + "\"]");
        return getFabricFromAsset($fabric);
    }
    function simpleSpecToDesign(spec) {
        var fabric = getFabricFrom(spec);
        var d = __assign({}, designbook_models_1.defaultDesign, { style: renderCustomValance_1.styleNamesMap["style_" + spec.style], size: spec.width + "\" W x " + spec.height + "\"L", fringe: design_1.getSpecDetailsText(spec, 'fringe'), product: {
                kind: productKindFrom(spec.productType),
                details: design_1.getSpecDetailsText(spec, 'product')
            }, fabric: fabric });
        return jQuery.Deferred().resolve(d);
    }
    function prepareAppTemplate(assets) {
        return {
            CDN_ROOT: "/code/" + assets['designbook-vendor.js'].split('/')[0],
            vendor_js: assets['designbook-vendor.js'].split('/')[1],
            designbook_js: assets['designbook.js'].split('/')[1]
        };
    }
    var setState = function (x) { return share_1.shareDialog({ ready: !!x.input, text: x.label, link: x.input, className: x.input ? 'copyDesignbook' : 'waiting', directLink: false }); };
    function showShareActionSheet(publishWithoutPrice) {
        share_1.shareDialog(publishWithoutPrice
            ? {
                ready: true,
                text: 'publish without price',
                link: 'bundle.default.designbook.createDesignBook(event)',
                className: 'publish',
                directLink: true
            }
            : null);
    }
    exports.showShareActionSheet = showShareActionSheet;
    function createDesignBook(e) {
        e.preventDefault();
        e.stopPropagation();
        var spec = renderCustomValance_1.getFullSpec(NaN, NaN);
        var getDesign = simpleSpecToDesign(spec);
        var _sasMap;
        var _design;
        var zoomIds = ['0', '1', '2'];
        var canvasFileNames = zoomIds.map(function (x) { return "canvas_" + x + ".jpg"; });
        var thumbnailFileNames = zoomIds.map(function (x) { return "thumbnail_" + x + ".jpg"; });
        var imageFileNames = thumbnailFileNames.concat(canvasFileNames);
        var pictures = zoomIds.map(function (x, i) { return ({
            thumbnail: thumbnailFileNames[i],
            full: canvasFileNames[i]
        }); });
        var files = ['index.html', 'design.json'].concat(imageFileNames);
        setState({
            visibility: 'visible',
            className: '',
            label: 'removing pricing info'
        });
        return getDesign
            .then(function (design) {
            _design = __assign({}, design, { images: pictures.concat([design.fabric.photo]) });
            return $.ajax({
                url: '/designbook/prepare',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(files)
            });
        })
            .then(function (sasMap) {
            var _a, _b;
            setState({
                visibility: 'visible',
                className: '',
                label: 'uploading design'
            });
            _sasMap = sasMap;
            var designUrl = _sasMap['design.json'];
            var appUrl = _sasMap['index.html'];
            var _c = url_1.parseUrl(appUrl).path.split('/'), _ = _c[0], container = _c[1], designCode = _c[2], others = _c.slice(3);
            var appTemplate = window.htmlTemplates['designBookApp.html'];
            var appHtml = util_1.template(appTemplate, __assign({ title: _design.title }, prepareAppTemplate(JSON.parse(window.htmlTemplates['designbook.assets.json']))));
            var uploads = [
                $.ajax({
                    url: designUrl,
                    type: 'PUT',
                    contentType: 'application/json',
                    data: JSON.stringify(__assign({}, _design, { designCode: designCode })),
                    headers: (_a = {}, _a['x-ms-blob-type'] = 'BlockBlob', _a)
                }),
                $.ajax({
                    url: appUrl,
                    type: 'PUT',
                    contentType: 'text/html',
                    data: appHtml,
                    headers: (_b = {}, _b['x-ms-blob-type'] = 'BlockBlob', _b)
                })
            ];
            return $.when.apply($, uploads);
        })
            .then(function () {
            setState({
                visibility: 'visible',
                className: '',
                label: 'preparing design sketches'
            });
            return $.when.apply($, zoomIds.map(function (x) { return renderCustomValance_1.renderSharableCanvas(x, false, 960); }).concat(zoomIds.map(function (x) { return renderCustomValance_1.renderSharableCanvas(x, true, 2400); })));
        })
            .then(function () {
            var renderedCanvases = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                renderedCanvases[_i] = arguments[_i];
            }
            setState({
                visibility: 'visible',
                className: '',
                label: 'uploading design sketches'
            });
            var imageFiles = renderedCanvases.map(function (c) { return canvas_1.canvasToJpegFile(c, 2400, 2400); });
            var uploads = imageFiles.map(function (x, i) {
                var _a;
                var imageName = imageFileNames[i];
                var imageUrl = _sasMap[imageName];
                return $.ajax({
                    url: imageUrl,
                    type: 'PUT',
                    processData: false,
                    contentType: 'image/jpeg',
                    data: x,
                    headers: (_a = {}, _a['x-ms-blob-type'] = 'BlockBlob', _a)
                });
            });
            return $.when.apply($, uploads);
        })
            .then(function () {
            var rootHtml = _sasMap['index.html'];
            var rootUrl = url_1.parseUrl(rootHtml);
            var _a = rootUrl.path.split('/'), _ = _a[0], root = _a[1], designCode = _a[2], bookNames = _a.slice(3);
            var designBookUrl = "http://" + cdnHost + "/" + designCode + "/";
            setState({
                visibility: 'visible',
                className: 'clipboard',
                input: designBookUrl,
                label: 'link without price'
            });
            return designBookUrl;
        });
    }
    exports.createDesignBook = createDesignBook;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/designbook.js
// module id = 43
// module chunks = 0